var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-radio-cards"},_vm._l((_vm.options),function(option){return _c('RadioCard',{key:option.id,attrs:{"option":option,"selected-option-id":_vm.selectedOptionId},on:{"input":_vm.handleInput}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }